// reducers/core/ribbon.js

export function ribbonHasErrored(state = false, action) {
  switch (action.type) {
    case 'RIBBON_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function ribbonIsLoading(state = true, action) {
  switch (action.type) {
    case 'RIBBON_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function ribbon(state = [], action) {
  switch(action.type) {
    case 'RIBBON_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}